module.exports = __webpack_public_path__ + "static/tp-logo-e3e935628acb0e235e3ee3ebcf3e0f4a.png";